module.exports = __webpack_public_path__ + "static/media/scout-mock-2.e297e647.png";